/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_No_Passkeys_DescriptionInputs */



/**
* | output |
* | --- |
* | "No passkeys yet." |
*
* @param {Partner_Security_No_Passkeys_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_no_passkeys_description = /** @type {((inputs?: Partner_Security_No_Passkeys_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_No_Passkeys_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Passkeys.")
	return /** @type {LocalizedString} */ ("No passkeys yet.")
});